export default "__VITE_PUBLIC_ASSET__924016f6__"